<div class="h-screen form-container">
    <div class="flex flex-wrap h-full">
      <div class="relative items-center justify-center hidden w-full lg:flex lg:w-1/2">
        <div class="absolute inset-0 z-10 bg-gray-900 opacity-40"></div>
        <img class="absolute inset-0 z-0 object-cover w-full h-full ml-auto" src="public/images/login-s.svg" />
      </div>
      <div class="w-full flex flex-col justify-between py-6 bg-gray-100 shadow-md lg:py-7 lg:w-1/2">
        <div class="pe-5"><img src="public/images/Logo.svg" class="ms-auto self-center" /></div>
        <div class="w-full max-w-md mx-auto self-center lg:full ">
          <div class="text-3xl text-mdPrimary-500 font-extrabold mb-4">Insite 360</div>
  
  
          <div
            class="w-full max-w-[35rem] mx-auto self-center shadow-lg bg-gray-50 dark:bg-gray-800 lg:full p-7 rounded-xl">
            <h3 class="mb-4 text-mdPrimary-500 font-extrabold text-xl">
              Sign up
            </h3>
            <form [formGroup]="signUpForm" class="p-0 m-0" (ngSubmit)="signUp()">
              <label for="input-group-1"
                class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold dark:text-white">First Name</label>
              <div class="relative mb-6">
                <mat-form-field appearance="outline">
                    <input matInput type="text" id="input-group-1" formControlName="firstName" placeholder="First Name">
                  </mat-form-field>
                <div *ngIf="submitted && f['firstName'].errors" class="mt-1 invalid-feedback text-red-500 text-xs">
                  <div *ngIf="f['firstName'].errors['required']">
                    First Name is required!
                  </div>
                </div>
              </div>
  
              <label for="input-group-1"
                class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold dark:text-white">Last Name</label>
              <div class="relative mb-6">
                <mat-form-field appearance="outline" color="primary">
                    <input matInput type="text" id="input-group-1" formControlName="lastName" placeholder="Last Name">
                  </mat-form-field>
                <div *ngIf="submitted && f['lastName'].errors" class="mt-1 invalid-feedback text-red-500  text-xs">
                  <div *ngIf="f['lastName'].errors['required']">
                    Last Name is required!
                  </div>
                </div>
              </div>
  
              <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Country</label>
              <div class="relative mb-6">
                <lib-select-option [optionData]="countryData" [formGroup]="signUpForm" formControlName="countryId" [submitted]="submitted" [placeHolderName]="'Country'"></lib-select-option>               
              </div>

              <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Region</label>
              <div class="relative mb-6">
                <lib-select-option [optionData]="regionData" [formGroup]="signUpForm" formControlName="region" [submitted]="submitted" [placeHolderName]="'Region'"></lib-select-option>
              </div>
  
              <label for="input-group-1"
                class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold">Email</label>
              <div class="relative">
                
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 16">
                    <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                    <path
                      d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
                  </svg>
                </div>
                <mat-form-field appearance="outline" class="email-field">
                <input matInput type="text" id="input-group-1" formControlName="email"
                  placeholder="Enter Your Email" required />
                </mat-form-field>
              </div>
  
              <div *ngIf="submitted && f['email'].errors" class="mt-1 invalid-feedback text-red-500 text-xs">
                <div *ngIf="f['email'].errors['required']">Email is required!</div>
                <div *ngIf="f['email'].errors['invalidDomain']">Email domain must be &#64;electrolux.com!</div>
              </div>
  
  
              <!-- <label for="" class="flex dark:text-gray-300 ">
                      <input type="checkbox" class="mt-1 mr-4 rounded">
                      <span class="text-sm ">I have read and agree with the <a routerLink="/auth/login"
                          class="text-sm ml-1 font-semibold text-blue-700 dark:text-blue-300 dark:hover:text-mdPrimary-500 underline underline-offset-4 ">
                          Terms of Service </a> and <a routerLink="/auth/login"
                          class="text-sm ml-1 font-semibold text-blue-700 dark:text-blue-300 dark:hover:text-mdPrimary-500 underline underline-offset-4 ">
                          Privacy Policy</a></span>
                  </label> -->
  
              <button class="w-full px-4 py-4 mt-12 font-medium text-white bg-mdPrimary-500 rounded"
                type="submit">
                Sign Up
              </button>
  
              <div class="mt-2 flex justify-center">
                <span class="text-sm font-normal text-blacktext">Already have an account?<a routerLink="/auth/login"
                    class="text-sm ml-1 font-normal text-[#007AFF] underline underline-offset-4 cursor-pointer">
                    Login now
                  </a></span>
              </div>
            </form>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>

  